/**
 * Add a temporal div with text to be readed by screen reader.
 * @param text
 */
export function srSpeak(text: string, type: string) {
  const el = document.createElement('div');
  const id = 'speak-' + Date.now();
  el.setAttribute('id', id);
  el.setAttribute('aria-live', type);
  el.setAttribute('role', 'status');
  el.classList.add('sr-only');
  document.body.appendChild(el);

  window.setTimeout(function () {
    const textNode = document.createTextNode(text);
    const element = document.getElementById(id);
    if (element) {
      while (element.firstChild) {
        element.removeChild(element.firstChild);
      }
      element.appendChild(textNode);
    }
  }, 100);

  window.setTimeout(function () {
    const element = document.getElementById(id);
    if (element && element.parentNode) {
      document.body.removeChild(element);
    }
  }, 1000);
}
